import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationDatasource = createCrudVuexModule({
  namespaced: true,
  path: "/datasource",
  state: {
    infoItem: null,
    info: null,
    isInfoLoading: null,
  },
  getters: {
    infoItem: (state) => state.infoItem,
    info: (state) => state.info,
    isInfoLoading: (state) => state.isInfoLoading,
  },
  mutations: {
    infoItem: (state, value) => (state.infoItem = value),
    info: (state, value) => (state.info = value),
    isInfoLoading: (state, value) => (state.isInfoLoading = value),
  },
  actions: {
    async fetchInfo({ commit }, { item, pagination }) {
      commit("isInfoLoading", true);
      commit("infoItem", item);

      try {
        const response = await rest.post(`/datasource/${item._id}/info`, { pagination });
        commit("info", response.data);
        return response;
      } finally {
        commit("isInfoLoading", false);
      }
    },
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/datasource/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
